import { render } from "./HelpLauncher.vue?vue&type=template&id=4b40d4e0&scoped=true"
import script from "./HelpLauncher.vue?vue&type=script&lang=js"
export * from "./HelpLauncher.vue?vue&type=script&lang=js"

import "./HelpLauncher.vue?vue&type=style&index=0&id=4b40d4e0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b40d4e0"]])

export default __exports__